import * as React from "react";
import { useState, useEffect} from "react"
import QuoteNew from "../quote_calculator/QuoteNew"
import QuoteEdit from "../quote_calculator/QuoteEdit"
import QuoteShow from "../quote_calculator/QuoteShow"
import { jfetch } from "../../utils"
import { useParams } from "react-router-dom";
import useQuote  from "../../hooks/useQuote";

interface IProps {
  userContext:any;
  subtype:string;
  cw_set:boolean;
}

function QuoteWrapper(props:IProps){
  let returnComponent;
  const [charges, setCharges] = useState([])
  const [productCategories, setProductCategories] = useState(null)
  const [serviceCategories, setServiceCategories] = useState(null)
  const [chargeCategories, setChargeCategories] = useState(null)
  const [projectServiceCategories, setProjectServiceCategories] = useState(null)
  const [company, setCompany] = useState('')
  const [contact, setContact] = useState('')
  const [email, setEmail] = useState('')
  const [notes, setNotes] = useState('')
  const [sold, setSold] = useState(null)
  const [isHAAS, setHAAS] = useState(false)
  const [servicesTotal, setServicesTotal] = useState(0)
  const [productsTotal, setProductsTotal] = useState(0)
  const [chargesTotal, setChargesTotal] = useState(0)
  const [monthlyRevenue, setMonthlyRevenue] = useState(0)
  const [monthlyExpense, setMonthlyExpense] = useState(0)
  // const [serviceExpense, setServiceExpense] = useState(0)
  // const [productExpense, setProductExpense] = useState(0)
  // const [chargeExpense, setChargeExpense] = useState(0)
  const [monthlyProfit, setMonthlyProfit] = useState(0)
  const [serviceProfit, setServiceProfit] = useState(0)
  const [productProfit, setProductProfit] = useState(0)
  const [chargeProfit, setChargeProfit] = useState(0) 
  const [dueAmount, setDueAmount] = useState(0)
  // const [dueAmountProfit, setDueAmountProfit] = useState(0) 
  const [withHAAS, setWithHAAS] = useState(0)
  const [withoutHAAS, setWithoutHAAS] = useState(0)
  const [LLGM, setLLGM] = useState(0)
  const [modifier, setModifier] = useState(0)
  const [burdenRate, setBurdenRate] = useState(0)
  const [billRate, setBillRate] = useState(0)
  const [projectServices, setProjectServices] = useState([])
  const [projectHours, setProjectHours] = useState(0)
  const [ROI, setROI] = useState(12)
  const [contractTerm, setContractTerm] = useState(36)
  const [chargesOnlyTotal, setChargesOnlyTotal] = useState(0)



  const { 
    products, 
    setProducts,
    services, 
    setServices,
    setAllCategories,
    setHasCw,
    setSubtype,
    serviceExpense, 
    setServiceExpense,
    productExpense,
    setProductExpense,
    chargeExpense,
    setChargeExpense,
    projectLaborExpense,
    setProjectLaborExpense,
    projectLaborRevenue,
    setProjectLaborRevenue,
    setServiceHours,
    chargesOnlyExpense,
    setChargesOnlyExpense
  } = useQuote()

  function updateService(id, new_entry){
    let services_copy = [...services]
    services_copy.forEach((service) => {
      if(service.id == id){
        service = new_entry
      }
    })
    setServices(services_copy);
  }

  function updateProduct(id, new_entry){
    let products_copy = [...products]
    products_copy.forEach((product) => {
      if(product.id == id){
        product = new_entry
      }
    })
    setProducts(products_copy);
  }
  
  function updateCharge(id, new_entry){
    let charges_copy = [...charges]
    charges_copy.forEach((charge) => {
      if(charge.id == id){
        charge = new_entry
      }
    })
    setCharges(charges_copy);
  }  

  function updateProjectService(id, new_entry){
    let services_copy = [...projectServices]
    services_copy.forEach((service) => {
      if(service.id == id){
        service = new_entry
      }
    })
    setProjectServices(services_copy);    
  }

  function formatProducts(categories){
    let new_products = []
    for (const category in categories) {
      const category_products = categories[category]
      new_products = new_products.concat(category_products)
    }
    setProducts(new_products)
    setProductCategories(categories)
  }

  function formatServices(categories, filter){
    let new_services = []
    for (const category in categories) {
      let category_services = categories[category]
      if(filter){
        category_services = category_services.filter((service) => service.for_project == false)
      }
      new_services = new_services.concat(category_services)
    }
    setServices(new_services)
    setServiceCategories(categories)
  }

  function formatProjectServices(categories){
    let new_servies = []
    for (const category in categories) {
      let category_servies = categories[category]
      category_servies = category_servies.filter((service) => service.for_project == true)
      new_servies = new_servies.concat(category_servies)
    }
    setProjectServices(new_servies)
    setProjectServiceCategories(categories)
  }

  function formatCharges(categories){
    
    let new_charges = []
    for (const category in categories) {
      const category_charges = categories[category]
      new_charges = new_charges.concat(category_charges)
    }
    setCharges(new_charges)
    setChargeCategories(categories)
  }  

  const event = new Event('quote_change');
  useEffect(() => {
    window.document.dispatchEvent(event);
  }, [])

  useEffect(() => {
    let services_revenue = []
    let services_expenses = []
    let service_hours = []
    services.forEach(s => {
      services_revenue.push(parseFloat(s.total))
      service_hours.push(parseFloat(s.default_hours) * parseFloat(s.qty))
      const expense = (parseFloat(s.pay_rate) * parseFloat(s.default_hours) * parseFloat(s.qty))
      services_expenses.push(expense)
    })
    const total_r = services_revenue.reduce((a,b) => a + b, 0)
    const total_e = services_expenses.reduce((a,b) => a + b, 0)
    const total_h = service_hours.reduce((a,b) => a+b, 0)
    setServiceHours(total_h)
    setServicesTotal(total_r)
    setServiceExpense(total_e)
    setServiceProfit(total_r - total_e)
  }, [services])

  useEffect(() => {
    let products_revenue = []
    let products_expenses = []
    products.forEach(p => {
      products_revenue.push(parseFloat(p.total))
      const expense = (parseFloat(p.cost_price) * parseFloat(p.qty))
      products_expenses.push(expense)
    })
    const total_r = products_revenue.reduce((a,b) => a + b, 0)
    const total_e = products_expenses.reduce((a,b) => a + b, 0)
    setProductsTotal(total_r)
    setProductExpense(total_e)
    setProductProfit(total_r - total_e)
  }, [products])

  useEffect(() => {
    let charges_revenue = []
    let charges_expenses = []
    charges.forEach(c => {
      charges_revenue.push(parseFloat(c.total))
      let expense = (parseFloat(c.cost_price) * parseFloat(c.qty))
      charges_expenses.push(expense)
    })
    let total_r = charges_revenue.reduce((a,b) => a + b, 0)
    let total_e = charges_expenses.reduce((a,b) => a + b, 0)
    setChargesTotal(total_r + projectLaborRevenue)
    setChargeExpense(total_e + projectLaborExpense)
    setChargeProfit(total_r - total_e)
  }, [charges, projectLaborRevenue, projectLaborExpense])


  useEffect(() => {
    let service_hours = []
    projectServices.forEach(s => {
      service_hours.push(parseFloat(s.total_hours))
    })
    let total_h = service_hours.reduce((a,b) => a+b, 0)
    // removed per nicks request
    //total_h = total_h + (total_h * .20) // added 20% increase to hours for project management
    setProjectHours(total_h)
    setProjectLaborRevenue(total_h*billRate)
    setProjectLaborExpense(total_h*burdenRate)
  }, [projectServices, billRate, burdenRate])
  

  useEffect(() => {
    setMonthlyExpense(serviceExpense + productExpense)
  }, [serviceExpense, productExpense, chargeExpense])

  useEffect(() => {
    setMonthlyProfit(monthlyRevenue - monthlyExpense)
  }, [monthlyRevenue, monthlyExpense])

  useEffect(() => {
    const amount = isHAAS ? withHAAS : withoutHAAS
    setMonthlyRevenue(amount)
  }, [isHAAS, withHAAS, withoutHAAS])

  useEffect(() => {
    const with_haas = servicesTotal + productsTotal + ((chargeExpense)/ROI) + modifier
    setWithHAAS(with_haas)
  }, [servicesTotal, productsTotal, chargeExpense, modifier, ROI])

  useEffect(() => {
    const with_no_haas = withHAAS - (chargesTotal / contractTerm)
    setWithoutHAAS(with_no_haas)
  }, [withHAAS, chargesTotal, modifier, contractTerm])

  useEffect(() => {
    const amount = isHAAS ? chargesTotal : 0
    setDueAmount(amount)
  }, [isHAAS, chargesTotal])

  useEffect(() => {
    setHasCw(props.cw_set)
    initQuote()
  }, [])

  useEffect(() => {
    setSubtype(props.subtype)
  }, [props.subtype])

  useEffect(() => {
    // loop through all the charges and calculate the total
    let total = 0
    let expense_total = 0
    charges.forEach(charge => {
      total += parseFloat(charge.total)
      expense_total += ( +charge.qty * +charge.cost_price )
    })
    setChargesOnlyTotal(total)
    setChargesOnlyExpense(expense_total)
  }, [charges])


  const { calculator_id }:any = useParams();
  const { quote_id }:any = useParams();
  
  async function initQuote(){
    if(props.subtype == 'edit' || props.subtype == 'show'){
      let quote_settings = await jfetch.get(`/organizations/${props.userContext.org.id}/quote_calculator/quote_calculator/${calculator_id}/quotes/${quote_id}`)
      let quote = quote_settings.quote
      setBurdenRate(quote.burden_rate)
      setBillRate(quote.bill_rate)
      setROI(quote.roi)
      setContractTerm(quote.contract_term)
    }
    else{
      let org_settings = await jfetch.get(`/organizations/${props.userContext.org.id}`)
      let s = org_settings["data"]["attributes"]["settings"]
      if(s){
        if(s.hasOwnProperty("laborPayRate")){
          setBurdenRate(s["laborPayRate"])
        }
        if(s.hasOwnProperty("laborBillRate")){
          setBillRate(s["laborBillRate"])
        }
        if(s.hasOwnProperty("quoteROI")){
          setROI(s["quoteROI"])
        }        
      }      
    }
  }

  useEffect(() => {
    let margin
    let contractRevenue = monthlyRevenue * contractTerm
    let contractExpense = ( ( serviceExpense + productExpense ) * contractTerm ) + chargeExpense
    let contactProfit = contractRevenue - contractExpense
    if(isHAAS){
      margin =  contactProfit / contractRevenue
    }
    else{
      margin = (  contactProfit + chargesTotal  ) / ( contractRevenue + chargesTotal )
    }
    setLLGM(margin)
  }, [isHAAS, monthlyRevenue, serviceExpense, productExpense, chargeExpense, chargesTotal, contractTerm])

  useEffect(() => {
    jfetch.get(`/organizations/${props.userContext.org.id}/quote_calculator/categories`)
    .then((resp) => {
      setAllCategories(resp.categories)
    })
  }, [])



  switch (props.subtype) {
    case "new":
      returnComponent = (
        <QuoteNew 
          userContext={props.userContext} 
          services={services}
          products={products}
          charges={charges}
          productCategories={productCategories}
          serviceCategories={serviceCategories}
          chargeCategories={chargeCategories}
          projectServiceCategories={projectServiceCategories}
          updateService={updateService}
          updateProduct={updateProduct}
          updateCharge={updateCharge}
          company={company}
          contact={contact}
          email={email}
          notes={notes}
          sold={sold}
          isHAAS={isHAAS}
          setCompany={(val) => setCompany(val)}
          setContact={(val) => setContact(val)}
          setEmail={(val) => setEmail(val)}
          setNotes={(val) => setNotes(val)}
          setSold={(val) => setSold(val)}
          setHAAS={(val) => setHAAS(val)}
          servicesTotal={servicesTotal}
          serviceProfit={serviceProfit}
          productsTotal={productsTotal}
          productProfit={productProfit}
          chargesTotal={chargesTotal}
          chargeProfit={chargeProfit}
          monthlyRevenue={monthlyRevenue}
          monthlyProfit={monthlyProfit}
          dueAmount={dueAmount}
          monthlyExpense={monthlyExpense}
          setServices={(val, b) => formatServices(val, b)}
          setProducts={(val) => formatProducts(val)}
          setCharges={(val) => formatCharges(val)}
          withHAAS={withHAAS}
          withoutHAAS={withoutHAAS}
          LLGM={LLGM}
          modifier={modifier}
          setModifier={(val) => setModifier(val)}
          billRate={billRate} // billable rate
          burdenRate={burdenRate}
          ROI={ROI}
          setBillRate={(val) => setBillRate(val)}
          setBurdenRate={(val) => setBurdenRate(val)}
          setROI={(val) => setROI(val)}
          contractTerm={contractTerm}
          setContractTerm={(val) => setContractTerm(val)}
          setProjectHours={(val) => setProjectHours(val)}
          projectServices={projectServices}
          setProjectServices={formatProjectServices}
          updateProjectService={updateProjectService}
          projectHours={projectHours}
          projectLaborRevenue={projectLaborRevenue}
          projectLaborExpense={projectLaborExpense}
          chargesOnlyTotal={chargesOnlyTotal}
        />
      )
      break;
    case "edit":
      returnComponent = (
        <QuoteEdit 
          userContext={props.userContext}
          services={services}
          products={products}
          charges={charges}
          productCategories={productCategories}
          serviceCategories={serviceCategories}
          chargeCategories={chargeCategories}
          projectServiceCategories={projectServiceCategories}
          updateService={updateService}
          updateProduct={updateProduct}
          updateCharge={updateCharge}
          company={company}
          contact={contact}
          email={email}
          notes={notes}
          sold={sold}
          isHAAS={isHAAS}
          setCompany={(val) => setCompany(val)}
          setContact={(val) => setContact(val)}
          setEmail={(val) => setEmail(val)}
          setNotes={(val) => setNotes(val)}
          setSold={(val) => setSold(val)}
          setHAAS={(val) => setHAAS(val)}
          servicesTotal={servicesTotal}
          serviceProfit={serviceProfit}
          productsTotal={productsTotal}
          productProfit={productProfit}
          chargesTotal={chargesTotal}
          chargeProfit={chargeProfit}
          monthlyRevenue={monthlyRevenue}
          monthlyProfit={monthlyProfit}
          dueAmount={dueAmount}
          monthlyExpense={monthlyExpense}
          setServices={(val, b) => formatServices(val, b)}
          setProducts={(val) => formatProducts(val)}
          setCharges={(val) => formatCharges(val)}
          withHAAS={withHAAS}
          withoutHAAS={withoutHAAS}
          LLGM={LLGM}
          modifier={modifier}
          setModifier={(val) => setModifier(val)}
          billRate={billRate}
          burdenRate={burdenRate}
          ROI={ROI}          
          setBillRate={(val) => setBillRate(val)}
          setBurdenRate={(val) => setBurdenRate(val)}
          setROI={(val) => setROI(val)}
          contractTerm={contractTerm}
          setContractTerm={(val) => setContractTerm(val)}
          projectServices={projectServices}
          setProjectServices={formatProjectServices}
          updateProjectService={updateProjectService}
          projectHours={projectHours}
          projectLaborRevenue={projectLaborRevenue}
          projectLaborExpense={projectLaborExpense}
          chargesOnlyTotal={chargesOnlyTotal}        
        />
        )
      break; 
    case "show":
      returnComponent = (
        <QuoteShow 
          userContext={props.userContext} 
          services={services}
          products={products}
          charges={charges}
          productCategories={productCategories}
          serviceCategories={serviceCategories}
          chargeCategories={chargeCategories}
          projectServiceCategories={projectServiceCategories}
          updateService={updateService}
          updateProduct={updateProduct}
          updateCharge={updateCharge}
          company={company}
          contact={contact}
          email={email}
          notes={notes}
          sold={sold}
          isHAAS={isHAAS}
          setCompany={(val) => setCompany(val)}
          setContact={(val) => setContact(val)}
          setEmail={(val) => setEmail(val)}
          setNotes={(val) => setNotes(val)}
          setSold={(val) => setSold(val)}
          setHAAS={(val) => setHAAS(val)}
          servicesTotal={servicesTotal}
          serviceProfit={serviceProfit}
          productsTotal={productsTotal}
          productProfit={productProfit}
          chargesTotal={chargesTotal}
          chargeProfit={chargeProfit}
          monthlyRevenue={monthlyRevenue}
          monthlyProfit={monthlyProfit}
          dueAmount={dueAmount}
          monthlyExpense={monthlyExpense}
          setServices={(val, b) => formatServices(val, b)}
          setProducts={(val) => formatProducts(val)}
          setCharges={(val) => formatCharges(val)}         
          withHAAS={withHAAS}
          withoutHAAS={withoutHAAS} 
          LLGM={LLGM}                   
          modifier={modifier}
          setModifier={(val) => setModifier(val)}
          billRate={billRate}
          burdenRate={burdenRate}
          ROI={ROI} 
          setBillRate={(val) => setBillRate(val)}
          setBurdenRate={(val) => setBurdenRate(val)}
          setROI={(val) => setROI(val)}   
          contractTerm={contractTerm}
          setContractTerm={(val) => setContractTerm(val)}          
          projectServices={projectServices}
          setProjectServices={formatProjectServices}
          updateProjectService={updateProjectService}
          projectHours={projectHours}
          projectLaborRevenue={projectLaborRevenue}
          projectLaborExpense={projectLaborExpense}
          chargesOnlyTotal={chargesOnlyTotal}   
        />
      )
      break;
    default:
      break;
  }
  return returnComponent;
}

export default QuoteWrapper


// WEBPACK FOOTER //
// ./app/javascript/components/quote_calculator/QuoteWrapper.tsx